// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".otrfieldset[data-v-d6b64434] {\n  border-radius: 10px;\n  border: 1px solid #8ec7f5;\n  margin-bottom: 20px;\n  padding: 16px;\n}\n.otrfieldset legend[data-v-d6b64434] {\n  padding: 5px 10px;\n  background-color: #1890ff;\n  color: #fff;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
